import { CardModalFormValues } from 'features/cards/components/new-card-modal/types/CardModalFormNames';
import { useDispatch } from 'react-redux';
import { disableExpiryDate, updateCardModalFormValues } from 'actions/cardActions';
import { getCardAccountDefaultRequest, updateCardModalMeta } from 'actions/cardActions';
import { getCardOptionsAction } from 'actions/storeActions';
import { useSelectCardFormValues } from 'selectors/selectors';
import { getPlasticType } from 'actions/maintenanceActions';
import { CardModalMeta } from 'features/cards/components/new-card-modal/types/CardModalMetaTypes';

export function useDispatchCardFormValues() {
  const dispatch = useDispatch();
  const formValues = useSelectCardFormValues();
  return (values: CardModalFormValues) => dispatch(updateCardModalFormValues({ ...formValues, ...values }));
}

export function useDispatchResetCardFormValues() {
  const dispatch = useDispatch();
  return () => dispatch(updateCardModalFormValues({}));
}

export function useDispatchGetPlasticType() {
  const dispatch = useDispatch();
  return (plasticCardName: string) => {
    if (!plasticCardName) return;
    dispatch(getPlasticType(plasticCardName));
  };
}

/**
 * Retrieves the prefill defaults and card options for the selected account.
 */
export function useDispatchGetCardDefaults() {
  const dispatch = useDispatch();
  return (contractNumber: string, assignedGrandfatherClientNumber: string) => {
    if (contractNumber == null) return;
    dispatch(
      getCardAccountDefaultRequest({
        contractNumber: contractNumber,
        grandParentAccountNumber: assignedGrandfatherClientNumber,
      })
    );
    dispatch(getCardOptionsAction(contractNumber, assignedGrandfatherClientNumber));
  };
}

/**
 * Used to update meta information for the card modal like fleet limiters, vas codes, and dollar limits options.
 */
export function useDispatchCardModalMeta() {
  const dispatch = useDispatch();
  return (meta: CardModalMeta) => {
    dispatch(updateCardModalMeta(meta));
  };
}

export function useDispatchDisableExpiryDate() {
  const dispatch = useDispatch();
  return (value: boolean) => {
    dispatch(disableExpiryDate(value));
  };
}
